import { render } from "./TabInformationsThird.vue?vue&type=template&id=60c3a736&scoped=true"
import script from "./TabInformationsThird.vue?vue&type=script&lang=js"
export * from "./TabInformationsThird.vue?vue&type=script&lang=js"

import "./TabInformationsThird.vue?vue&type=style&index=0&id=60c3a736&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c3a736"]])

export default __exports__